import { colors } from 'Constants/Colors';
import { Paper, TextField } from '@mui/material';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { CustomDatePickerContainer, CustomDatePickerLabel } from './CustomDatePicker.styled';
import type { DateTime } from 'luxon';

interface Props {
  label?: string;
  value?: DateTime | null;
  onChange?: (value: DateTime | null) => void;
  placeholder?: string;
  fullWidth?: boolean;
}

const CustomDatePicker = ({ label, value = null, onChange, placeholder, fullWidth = false }: Props) => {
  return (
    <CustomDatePickerContainer>
      <CustomDatePickerLabel hidden={!label}>{label}</CustomDatePickerLabel>
      <LocalizationProvider dateAdapter={AdapterLuxon}>
        <Paper
          variant="outlined"
          sx={{
            padding: '0.5rem',
            alignItems: 'center',
            display: 'flex',
            gap: '0.5rem',
            height: '50px',
            ...(fullWidth
              ? { width: '100%', boxSizing: 'border-box' }
              : { width: '150px' }),
          }}
        >
          <DatePicker
            value={value}
            onChange={onChange}
            inputFormat="dd/MM/yyyy"
            clearable
            renderInput={params => (
              <TextField
                {...params}
                fullWidth={fullWidth}
                variant="standard"
                inputProps={{
                  ...params.inputProps,
                  placeholder,
                }}
                InputProps={{
                  ...params.InputProps,
                  disableUnderline: true,
                  style: { color: value ? 'black' : colors.GRAY },
                  sx: {
                    '& input': {
                      padding: 0,
                      cursor: 'pointer',
                      '&::placeholder': {
                        color: colors.GRAY,
                        opacity: 1,
                      },
                    },
                  },
                }}
              />
            )}
          />
        </Paper>
      </LocalizationProvider>
    </CustomDatePickerContainer>
  );
};

export default CustomDatePicker;
